// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Qebj","topBottomGutter":"Layout_topBottomGutter___-JXK"};